module.exports = __webpack_public_path__ + "img/business-and-finance.df70ebe9.svg";